export enum ProductPlanCodes {
  INSTALLMENTS = 'INSTALLMENTS',
  PAYDAY = 'PAYDAY',
  MICRO = 'MICRO',
}

export enum ProductPeriodUnit {
  MONTH = 'MONTH',
  DAY = 'DAY',
}

export interface Product {
  id: number;
  name: string;
  code: ProductPlanCodes;
  // Owning brand. Typed as string rather than BrandCodes: the backend has brands the
  // partners app does not model, and a partner may hold products from more than one.
  // Product code is not unique across brands, so code alone does not identify a product.
  brandCode: string;
  apr: number;
  periodUnit: ProductPeriodUnit;
}

export interface ProductPlan {
  id: number;
  product: Product;
  principal: number;
  installmentsNumber: number;
  installmentDays: number;
  dailyInterest: number;
  apr: number;
  installmentAmount: number;
  installmentForfeit: number;
  installmentUtilizationFee: number;
}
